export default "__VITE_ASSET__CY$V4gKO__"